import {createReducer, on} from '@ngrx/store';
import {
  ClearState,
  FetchNotificationListFailure,
  FetchNotificationListRequest,
  FetchNotificationListSuccess,
  SendMarkAsCheckedNotificationData,
} from "./notifications.actions";
import {NotificationItemModel} from "../model/notification-model";
import {
  DeleteNotificationFailure,
  DeleteNotificationRequest,
  DeleteNotificationSuccess,
  MarkNotificationAsReadFailure,
  MarkNotificationAsReadRequest,
  MarkNotificationAsReadSuccess
} from 'src/app/modules/shared/core/shared.actions';

// State for this feature (User)
export interface NotificationsState {
  loading: boolean,
  notification: {
    total: number,
    pageNumber: number,
    limit: number,
    hasNext: boolean,
    hasPrev: boolean,
    list: NotificationItemModel[]
  }
}

const initialState: NotificationsState = {
  loading: false,
  notification: {
    hasNext: false,
    hasPrev: false,
    limit: 0,
    list: [],
    pageNumber: 0,
    total: 0
  }
};

export const reducer = createReducer(
  initialState,
  //fetch list
  on(FetchNotificationListRequest, (state, props) => ({
    ...state,
    loading: true,
    notification: {
      ...state.notification,
      ...(props.payload.pageNumber ? {list: props.payload.pageNumber === 1 ? [] : [...state.notification.list]}:{})
    }
  })),

  on(FetchNotificationListSuccess, (state, props) => ({
    ...state, loading: false, notification: {
      ...props.payload, list: props.payload.pageNumber === 1 ? props.payload.list : [
        ...state.notification.list, ...props.payload.list
      ]
    }
  })),

  on(FetchNotificationListFailure, (state) => (
    {
      ...state,
      loading: false,
      notification: initialState.notification
    }
  )),

  //mark notification as read

  on(MarkNotificationAsReadRequest, state => state),

  on(MarkNotificationAsReadSuccess, (state, props) => state
  ),

  on(MarkNotificationAsReadFailure, state => state),

  //mark as checked
  on(SendMarkAsCheckedNotificationData, (state, props) =>
    ({
      ...state, notification: {
        ...state.notification, list: props.payload.list
      }
    })),

  //delete notifications
  on(DeleteNotificationRequest, state => state),

  on(DeleteNotificationSuccess, (state, props) => state),

  on(DeleteNotificationFailure, state => state),

  // CLEAR STATE 
  on(ClearState, () => initialState),
);
